<div class="itinerary-model-content-inner">
  <div class="itinerary-model-content">
    <form [formGroup]="itemsForm">
      <div class="box-title-container mb-1" *ngIf="!generatingVoucher">
        <div class="">
          <div class="d-flex align-items-center">
            <div class="icon-container">
              <ion-icon name="duplicate"></ion-icon>
            </div>
            <div>
              <p class="title">Inclusion & Exclusion</p>
            </div>
          </div>
        </div>
      </div>
      <div class="form-container ion-padding-horizontal">
        <div class="row">
          <div class="col">
            <div class="input-container">
              <label for="" class="label">Include</label>
              <app-selectable-list-items 
                [addButtonText]="'Add Inclusions'"
                formControlName="include"
                (setDefaultEmitter)="setDefaultLov($event, 'Inclusion', 'include')"
                (removeDefaultEmitter)="removeDefaultLov($event, 'Inclusion', 'include')"
              ></app-selectable-list-items>
            </div>
          </div>
        </div>

        <div class="add-inclusion-main-container">
          <div class="row">
            <div class="col">
              <div class="input-container">
                <label for class="label">Inclusion Notes</label>
                <div>
                  <app-text-formatting-input formControlName="inclusionNote"></app-text-formatting-input>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="input-container">
              <label for="" class="label">Exclude</label>
              <app-selectable-list-items 
                [addButtonText]="'Add Exclusions'"
                formControlName="exclude"
                (setDefaultEmitter)="setDefaultLov($event, 'Exclusion', 'exclude')"
                (removeDefaultEmitter)="removeDefaultLov($event, 'Exclusion', 'exclude')"
              ></app-selectable-list-items>
            </div>
          </div>
        </div>

        <div class="add-inclusion-main-container">
          <div class="row">
            <div class="col">
              <div class="input-container">
                <label for class="label">Exclusion Notes</label>
                <div>
                  <app-text-formatting-input formControlName="exclusionNote"></app-text-formatting-input>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dashed-line"></div>
    </form>
  </div>

  <div class="ion-padding-horizontal justify-content-between itinerary-model-footer" *ngIf="!generatingVoucher && !hideFooter">
    <div class="d-flex align-items-center">
      <ion-button class="unfilled-blue-btn" [disabled]="formDataModified()" (click)="goPrevious()">
        <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
      </ion-button>
      <ion-button class="unfilled-blue-btn" (click)="resetForm()" [disabled]="!formDataModified()">
        Reset
      </ion-button>
    </div>
    
    <div class="d-flex align-items-center">
      <ion-button class="filled-blue-btn" (click)="onSubmit()" [disabled]="!formDataModified() && storedFormData">
        Save
      </ion-button>
      <ion-button class="filled-blue-btn" (click)="saveAndNext()" [disabled]="!formDataModified() && storedFormData">
        Save & Next
      </ion-button>
      <ion-button class="unfilled-blue-btn" (click)="goNext()" [disabled]="formDataModified()">
        <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
      </ion-button>
    </div>
  </div>
</div>

